import ReactAngularWidget, {
  NgWrapperDivProps,
} from '@react-bridge/react-angular-widget';

import { RoutableStateName } from 'app/top-level-states';

interface IAnchorWidgetProps {
  className?: string;
  state: RoutableStateName;
  stateParams: object;
  text: string;
}

export default class AnchorWidget extends ReactAngularWidget<
  IAnchorWidgetProps & { ngWrapperDivProps?: NgWrapperDivProps }
> {
  public static defaultProps = {
    stateParams: {},
  };

  protected html() {
    return '<a ng-class="className" ng-cloak ui-sref="{{state}}(stateParams)" ng-bind="text"></a>';
  }
}
